import BaseAPI from './base/base-api';

class NotificationAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'notification';
}

export default new NotificationAPI();
